var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},[_c('ScrollingBox',{staticClass:"scroll"},[_c('BarChart',{attrs:{"list":_vm.list,"legends":_vm.legends,"availableBy":_vm.availableBy}})],1),_c('div',{staticClass:"top"}),_c('div',{staticClass:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }